import Color from '../Color.mjs'
import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    catProp: 'bjCat',
    codeProp: 'bjNo',
    mapProp: 'bjMap',
    name: '业务作业',
    ownerIdProp: 'bfId',
    ownerTextProp: 'bfName',
    ownerType: 'BF',
    textProp: 'bjName',
    type: 'BJ',
}
